import { CardStatus } from '../../../../hoc/common/cards/types';

import cn from '../styles.module.css';

const getCardStatusClassName = (status: CardStatus) => {
  let className;

  switch (status) {
    case CardStatus.NEW:
      className = cn.new;
      break;
    case CardStatus.ORDERED:
      className = cn.ordered;
      break;
    case CardStatus.ACTIVE:
      className = cn.active;
      break;
    case CardStatus.FROZEN:
      className = cn.frozen;
      break;
    case CardStatus.CANCELED:
      className = cn.canceled;
      break;
    case CardStatus.VOID:
      className = cn.void;
      break;
    default:
      break;
  }

  return className;
};

export default getCardStatusClassName;
